class FileExportComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', (event) => this.configure(event.detail))
    document.addEventListener('project-updated', (event) => this.configure(event.detail))
  }

  configure(project) {
    document.getElementById('json-export-text-area').innerHTML = JSON.stringify(project)
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="mb-3">
      <label for="json-export-text-area" class="form-label">JSON Export</label>
      <textarea class="form-control" id="json-export-text-area" rows="10"></textarea>
    </div>
    `
  }
}

customElements.define('file-export-component', FileExportComponent)
